import Form from "../../../models/form";
import { FETCH_FORM_SUCCESS } from "./actions";

const initialState = {
	forms: null,
	isLoading: null
};

/**
 * Reducer managing Form.
 *
 * @name FormReducer
 *
 * @param {Object} state - Current application state
 * @param {AbstractAction} action - Action to dispatch
 * @return {Object} new state
 */
export default (state = initialState, action) => {
	switch (action.type) {
		case FETCH_FORM_SUCCESS: {
			let { data } = action.payload;
			let forms = data.map(form => new Form(form));

			return {
				...state,
				forms
			};
		}
		default:
			return state;
	}
};
